import { render, staticRenderFns } from "./DropdownV1.vue?vue&type=template&id=79b85f89&"
import script from "./DropdownV1.vue?vue&type=script&lang=js&"
export * from "./DropdownV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports